<template>
  <div class="indicators">
    <div class="pages">
      <div class="page-item-text">
        {{ labels.pageIndicators.question }}
        {{ page.current }} {{ labels.pageIndicators.of }}
        {{ page.total }}
      </div>

      <div
        class="page-item"
        v-for="index in page.total"
        :class="{
          visited: index <= page.current,
          current: index == page.current,
        }"
        :key="index"
      ></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

const props = {
  page: {
    type: Object,
    required: true,
  },
}

export default {
  props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    labels() {
      return this.resources.component
    },
  },
}
</script>

<style scoped lang="scss">
@import '~@/styles/custom/colors';

.indicators {
  align-items: center;
  border-radius: 15px;
  display: inline-flex;
  flex-flow: column;
  margin: 5px;
  padding: 3px;

  .text {
    color: map-get($theme-colors, 'gray03');
    margin-left: 5px;
    margin-right: 5px;

    @media (max-width: 375px) {
      display: none;
    }
  }

  .pages {
    align-items: center;
    background: rgba(204, 204, 204, 0.4);
    border-radius: 32px;
    padding: 0.4rem 0.8rem;
    display: flex;
    flex-wrap: wrap;
    max-width: 600px;
    overflow: hidden;
    width: auto;

    @media (max-width: 768px) {
      padding: 0.4rem;
    }

    .page-item-text {
      margin-right: 5px;
      min-width: 60px;

      @media (max-width: 1023px) {
        display: none;
      }
    }

    .page-item {
      background-color: white;
      border-radius: 18px;
      display: inline-block;
      margin: 3px 4px;
      min-width: 18px;
      height: 18px;

      &.visited {
        background-color: map-get($theme-colors, 'secondary');
      }

      &.current {
        background-color: map-get($theme-colors, 'red');
      }

      @media (max-width: 768px) {
        align-items: center;
        height: 15px;
        padding: 0;
        width: 15px;
        margin: 0 2px;
      }

      @media (max-width: 375px) {
        height: 10px;
        width: 10px;
      }

      @media (max-width: 320px) {
        height: 9px;
        width: 9px;
      }
    }
  }
}
</style>
